import { Grid, Stack } from "@mui/material";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import TopSection from "../../../Components/Common/Top/TopSection";
import CIHistoryTracker from "./CIHistoryTracker";
import { setActiveDataElement } from "../../../redux/userSlice";



const CIHistory = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveDataElement("Concentrate Inventory"));
  }, [dispatch]);

  return (
    <>
      <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TopSection
              title="Concentrate Inventory Upload History"
            />
            <div class="container">
              {/* top table */}
              <CIHistoryTracker></CIHistoryTracker>
             
            </div>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
};

export default CIHistory;
